import labels_BR from './static/generalDataBR';

const getGeneralDataBR = () => {
  return labels_BR;
};

export default getGeneralDataBR;